import React, { createContext, useContext, useEffect } from "react";
import { setupTokenExpirationCheck } from "../utils/tokenManager";

const TokenExpirationContext = createContext();

export const useTokenExpiration = () => useContext(TokenExpirationContext);

export const TokenExpirationProvider = ({ children }) => {
  useEffect(() => {
    // Configurar la verificación de expiración del token
    const interval = setupTokenExpirationCheck(60000); // Verificar cada minuto

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(interval);
  }, []);

  return (
    <TokenExpirationContext.Provider value={{}}>
      {children}
    </TokenExpirationContext.Provider>
  );
};
